const messages = [
  {
    title: 'Proxy virtuoso',
    text:
      'Amazing! You’re a foremost authority on proxy voting. You get the ins and outs — and even the nuances. Go ahead, don’t be shy: Share your proxy knowledge with others. The more you share, the bigger impact you can make.',
  },

  {
    title: 'Proxy smart',
    text:
      'Excellent work! Although you didn’t hit every note perfectly, it’s clear you have the basics down pat. There’s always room to improve and new opportunity to learn. Don’t wait. Share your insight with others. The more you share, the bigger impact you can make. ',
  },

  {
    title: 'Proxy rising star',
    text:
      'Good job! This stuff can be complicated, but you’re well on your way. Most importantly, you’re poised to learn more. Start a conversation. Get informed. And share your views with others. The more you share, the bigger impact you can make. ',
  },

  {
    title: 'Proxy trainee',
    text:
      'Not bad! You missed some questions, but you have a good foundation. There’s always something new to learn and discover. Don’t wait. Take advantage of the resources we created and help others get informed too. The more you share, the bigger impact you can make.',
  },
]

export default messages
